// Copyright 2025 Mo-Sys Engineering Ltd. All Rights Reserved.
import Cookies from 'js-cookie';

// Helper to determine if we are in production (or using HTTPS)
const isSecure = () => {
  if (typeof window !== 'undefined') {
    return window.location.protocol === 'https:';
  }

  return true;
};

// Utility functions for managing authentication tokens in cookies
// accessToken: The access token string with its type (e.g., "Bearer") and expiration time in seconds
// token: access_token string (ex.used for webSocket authentication)
// refreshToken: refresh_token string
const tokenOption = expiresIn => {
  const options = {
    secure: isSecure(),
    sameSite: 'Strict',
  };
  if (expiresIn) {
    const expiryTimeInDays = expiresIn / 86400; // Convert seconds to days
    options.expires = expiryTimeInDays;
  }
  return options;
};

export const storeTokens = (accessToken, tokenType, expiresIn) => {
  const options = tokenOption(expiresIn);
  Cookies.set('accessToken', `${tokenType} ${accessToken}`, options);
};

export const setToken = (token, expiresIn) => {
  const options = tokenOption(expiresIn);
  Cookies.set('token', token, options);
};

export const setRefreshToken = refreshToken => Cookies.set('refreshToken', `${refreshToken}`);

export const getAccessToken = () => Cookies.get('accessToken');
export const getToken = () => Cookies.get('token');
export const getRefreshToken = () => Cookies.get('refreshToken');

export const removeAccessTokens = () => Cookies.remove('accessToken');
export const removeToken = () => Cookies.remove('token');
export const removeRefreshToken = () => Cookies.remove('refreshToken');

export const clearAllTokens = () => {
  removeAccessTokens();
  removeToken();
  removeRefreshToken();
};
